import base from "./base.service";

const getUserProfile = () => base.get('/users/profile');
const buildPilotProfile = payload => base.put('/users/buildPilotProfile', payload);
const getSpeclialisedList = () => base.get('/users/speclialisedList');
const updateUserLocation = payload => base.put('/users/updateUserLocation', payload);
const updateProfile = payload => base.put('/users/updateProfile', payload);
const updatePilotProfile = payload => base.put('/users/updatePilotProfile', payload);
const updateProfilePicture = payload => base.put('/users/updateProfilePicture', payload);
const updateRadius = payload => base.put('/users/updatePilotJobLocationRadius', payload);
const deleteAccount = payload => base.get('users/deleteAccount', payload)
const getRole = () => base.get('users/roles')
const fetchPilotsWithCords = (params) => base.get('users/pilot-list', { params })
export const userService = {
    getUserProfile,
    buildPilotProfile,
    getSpeclialisedList,
    updateUserLocation,
    updateProfile,
    updatePilotProfile,
    updateProfilePicture,
    updateRadius,
    deleteAccount,
    getRole,
    fetchPilotsWithCords
}